import { useOutletContext } from 'react-router-dom';
import { CompanyDashboard } from '@/components/dashboard/CompanyDashboard';
import type { AppShellContext } from '@/components/layout/AppShell';

export function DashboardPage() {
  const { nip, companyName } = useOutletContext<AppShellContext>();
  return <CompanyDashboard companyNip={nip} companyName={companyName} />;
}
